import { AfterViewInit, Component, inject, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { Footer } from './core/components/footer/footer';
import { Header } from './core/components/header/header';
import AOS from 'aos';
import { OverlayService } from './core/services/overlay.service';
import { Whatsapp } from './core/components/whatsapp/whatsapp';
import { ContactUsModal } from "./pages/contact-us/contact-us-modal";
import { ChatComponent } from './core/components/chatbot/chatbot';
import { EmailVerifyBanner } from './core/components/email-verify-banner/email-verify-banner';
import { CartDrawer } from './core/components/cart-drawer/cart-drawer';

@Component({
  selector: 'app-root',
  imports: [Header, Footer, RouterOutlet, Whatsapp, ChatComponent, EmailVerifyBanner, CartDrawer],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements AfterViewInit{
  protected readonly title = signal('biowellness-web');
  public readonly overlayService = inject(OverlayService);
  // Admin and Business routes each get a completely separate layout (no storefront
  // header/footer/banners) — see app.html. Angular still uses one root component, so this just
  // toggles which chrome renders.
  private static isBackofficeUrl(url: string): boolean {
    return url.startsWith('/admin') || url.startsWith('/business');
  }
  public readonly isBackofficeRoute = signal(false);

  constructor(private router: Router)
  {
    this.isBackofficeRoute.set(App.isBackofficeUrl(this.router.url));
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
         this.overlayService.hideOverlay();
         this.isBackofficeRoute.set(App.isBackofficeUrl(evt.urlAfterRedirects));
        AOS.refresh();
      } else if (evt instanceof NavigationCancel || evt instanceof NavigationError) {
        // A guard (e.g. checkoutGuard) can cancel navigation instead of completing it — that
        // fires NavigationCancel, not NavigationEnd, so without this the loading overlay would
        // stay stuck on-screen (it defaults to visible) covering whatever the guard shows instead.
        this.overlayService.hideOverlay();
      }
    });
  }

  ngAfterViewInit(): void {
    AOS.init({ duration: 800, once: true });
  }
}
